export class Errors {
	constructor() {
		this.list = {}
	}

	get(field) {
		if (this.list[field]) {
			return this.list[field]
		}
	}

	any() {
		return Object.keys(this.list).length > 0;
	}

	record(error) {
		this.list[error.name] = error.message;
	}

	clear(field)  {
		delete this.list[field]
	}

	clearAll()  {
		this.list = {}
	}
}

export class Validator {
	constructor() {

		this.validationTypes = {
			required: 'checkRequired',
			checkLength: 'checkLength'
		}

	}

	validate(fields, errors, vm) {

		const types = Object.keys(this.validationTypes); //получаем список типов валидации

		for (const fieldName in fields) { //разбираем список полей

			const field = fields[fieldName]
			
			if(field && field.validationData) {
				for (const validation of field.validationData) { //разбираем список с информацией о валидации

					const check = false;

					const novalid = types.some((item) => {
						const method = this.validationTypes[item];

						const isError = validation.type == item ? this[method](field, validation) : false;

						return isError ? errors.record({name: field.name, message: validation.message}) : false

					})

					if(novalid) break; 
				}
			}
		}

		if(vm) vm.$forceUpdate();
    }

    validateField(field, errors, vm) {
        const types = Object.keys(this.validationTypes);
        if (field && field.validationData) {
            const errorArray = [];
            let novalidField;
            for (const validation of field.validationData) { //разбираем список с информацией о валидации

                const check = false;

                const novalid = types.some((item) => {
                    const method = this.validationTypes[item];

                    const isError = validation.type == item ? this[method](field, validation) : false;

                    errorArray.push(isError);

                    return isError ? errors.record({ name: field.name, message: validation.message }) : false

                })

                if (novalid) break;
            }

            const indices = errorArray.reduce(
                (out, bool, index) => bool ? out.concat(index) : out,
                []
            )

            if (indices.length == 0) errors.clear(field.name);
        }
        
        if (vm) vm.$forceUpdate();
    }

	checkRequired(field) {
		return !field.value
	}

	checkLength(field, validation) {
		return field.value.length < validation.length
	}
}